import classNames from 'classnames'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../Checkbox'
import { ICON_COLOR, IconSpinnerOverlay } from '../../Icon'
import { isTaskStatusTypeNo } from '../Task.utils'

import { QA_NAME_TASK_STATUS_TOGGLE } from './TaskStatusToggle.constants'

import * as styles from './TaskStatusToggle.module.css'

function TaskStatusToggle({
  checked,
  disabled,
  isLoading,
  qaName = QA_NAME_TASK_STATUS_TOGGLE,
  text,
  tooltip,
  type,
  onChange,
}) {
  const toggleClassName = classNames(styles.TaskStatusToggle, {
    [styles.no]: isTaskStatusTypeNo(type),
  })

  const iconClassName = classNames({ [styles.loadingIcon]: isLoading })

  return (
    <div className={toggleClassName}>
      <Checkbox
        showTooltip
        checked={checked}
        disabled={disabled || isLoading}
        iconClassName={iconClassName}
        label={text}
        qaName={qaName}
        size={CHECKBOX_SIZE.small}
        tooltip={tooltip}
        type={CHECKBOX_TYPE.rounded}
        onChange={onChange}
      />
      {isLoading ? (
        <div className={styles.loadingOverlay}>
          <IconSpinnerOverlay color={ICON_COLOR.SecondaryTextColor} />
        </div>
      ) : null}
    </div>
  )
}

export default TaskStatusToggle
